module.exports = __webpack_public_path__ + "img/banner04_info_pic3.1f0b8bfe.jpg";